import type { SavedFilter, SavedFilterCriteria } from '@/entities/saved-filter';
import { clock } from '@/services/clock';

import { FILTER_KEYS, NEW_DATA_URL_PARAM } from '../constants';
import type { FilterState } from '../types/filter.types';

export const toSavedFilterCriteria = (filters: FilterState): SavedFilterCriteria => ({
  only: filters.only,
  newData: filters[NEW_DATA_URL_PARAM],
  [FILTER_KEYS.COMMODITY]: filters[FILTER_KEYS.COMMODITY],
  [FILTER_KEYS.TRADING_HUB]: filters[FILTER_KEYS.TRADING_HUB],
  [FILTER_KEYS.DELIVERY_BASIS]: filters[FILTER_KEYS.DELIVERY_BASIS],
  [FILTER_KEYS.PRICING_BASIS]: filters[FILTER_KEYS.PRICING_BASIS],
  [FILTER_KEYS.UNITS]: filters[FILTER_KEYS.UNITS],
  [FILTER_KEYS.CURRENCY]: filters[FILTER_KEYS.CURRENCY],
  [FILTER_KEYS.FREQUENCY]: filters[FILTER_KEYS.FREQUENCY],
  [FILTER_KEYS.INDEX_MODULE]: filters[FILTER_KEYS.INDEX_MODULE]
});

export const buildSavedFilter = (name: string, criteria: SavedFilterCriteria): SavedFilter => ({
  id: crypto.randomUUID(),
  name,
  createdAt: clock.date().toISOString(),
  criteria
});

export const sortSavedFiltersByNewest = (savedFilters: SavedFilter[]): SavedFilter[] =>
  savedFilters.toSorted(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
